import React from "react";

function LockAlt() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="lock-alt" className="svg-inline--fa fa-lock-alt fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M152 225H72v-72C72 69.2 140.2 1 224 1s152 68.2 152 152v72h-80v-72a72 72 0 0 0-144 0z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M400 225H48a48 48 0 0 0-48 48v192a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V273a48 48 0 0 0-48-48zM264 392a40 40 0 0 1-80 0v-48a40 40 0 0 1 80 0z"></path></g></svg>
    );
  }

export default LockAlt;